"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.calculateOptions = exports.add = exports.remove = void 0;
var flatten_1 = __importDefault(require("lodash/flatten"));
var times_1 = __importDefault(require("lodash/times"));
var line_of_coverage_type_option_1 = require("../../utils/line-of-coverage-type-option");
function remove(options, toRemove) {
    return line_of_coverage_type_option_1.sortOptions(options.filter(function (_a) {
        var id = _a.id;
        return id !== toRemove.id;
    }));
}
exports.remove = remove;
function add(options, toAdd) {
    return line_of_coverage_type_option_1.sortOptions(__spreadArray(__spreadArray([], options), [toAdd]));
}
exports.add = add;
/**
 * Calculates the new available options covering the selected options and default options for the policy type
 * @param defaultOptions
 * @param selectedOptions
 */
function calculateOptions(defaultOptions, selectedOptions) {
    var lastIndexPerType = {};
    flatten_1.default([selectedOptions, defaultOptions]).forEach(function (_a) {
        var index = _a.index, type = _a.type;
        var currentLastIndex = lastIndexPerType[type] || 0;
        lastIndexPerType[type] = currentLastIndex < index ? index : currentLastIndex;
    });
    var options = flatten_1.default(Object.entries(lastIndexPerType).map(function (_a) {
        var type = _a[0], lastIndex = _a[1];
        return times_1.default(lastIndex + 1, function (index) { return line_of_coverage_type_option_1.toOption(type, index); });
    }));
    return line_of_coverage_type_option_1.sortOptions(options);
}
exports.calculateOptions = calculateOptions;
